"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var perfect_scrollbar_component_1 = require("./lib/perfect-scrollbar.component");
exports.PerfectScrollbarComponent = perfect_scrollbar_component_1.PerfectScrollbarComponent;
var perfect_scrollbar_directive_1 = require("./lib/perfect-scrollbar.directive");
exports.PerfectScrollbarDirective = perfect_scrollbar_directive_1.PerfectScrollbarDirective;
var perfect_scrollbar_interfaces_1 = require("./lib/perfect-scrollbar.interfaces");
exports.Geometry = perfect_scrollbar_interfaces_1.Geometry;
exports.PerfectScrollbarConfig = perfect_scrollbar_interfaces_1.PerfectScrollbarConfig;
var perfect_scrollbar_module_1 = require("./lib/perfect-scrollbar.module");
exports.PerfectScrollbarModule = perfect_scrollbar_module_1.PerfectScrollbarModule;
exports.PERFECT_SCROLLBAR_CONFIG = perfect_scrollbar_module_1.PERFECT_SCROLLBAR_CONFIG;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/ngx-perfect-scrollbar/dist/index.js
// module id = ../../../../ngx-perfect-scrollbar/dist/index.js
// module chunks = 13